import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import TrainingService from '../services/TrainingService';
import { normalizeImageUrl } from '../utils/imageUtils';

const TrainingPage = () => {
    const [trainingCourses, setTrainingCourses] = useState([]);
    const [loading, setLoading] = useState(true);

    const isFetchingRef = useRef(false);
    const lastFetchedRef = useRef(false);

    useEffect(() => {
        const fetchCourses = async () => {
            if (isFetchingRef.current) return;
            if (lastFetchedRef.current) return;

            isFetchingRef.current = true;
            try {
                const data = await TrainingService.getAllCourses();
                // Chỉ lấy khóa học đã xuất bản
                const publishedCourses = Array.isArray(data) ? data.filter(course => course.status === 'PUBLISHED') : [];
                setTrainingCourses(publishedCourses);
                lastFetchedRef.current = true;
            } catch (error) {
                console.error("Lỗi tải danh sách đào tạo:", error);
            } finally {
                setLoading(false);
                isFetchingRef.current = false;
            }
        };

        fetchCourses();
    }, []);

    return (
        <main className="product-category" style={{ borderBottom: '1px solid #ececec', paddingBottom: 20 }}>
            {/* ════ MINIMAL BREADCRUMBS ════ */}
            <div className="py-4 mt-[50px]">
                <div className="container px-4 text-left">
                    <nav aria-label="breadcrumb">
                        <ol className="flex items-center gap-2 text-xs md:text-sm uppercase tracking-wider mb-0 p-0 list-none">
                            <li className="breadcrumb-item">
                                <Link to="/" className="hover:text-red-600 transition-colors no-underline text-slate-500">Trang chủ</Link>
                            </li>
                            <span className="opacity-30">/</span>
                            <li className="breadcrumb-item active text-slate-900 font-bold" aria-current="page">
                                Đào tạo
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="container">
                <h1 className="heading-primary text-center" style={{ margin: '60px 0' }}>
                    <span>Đào tạo</span>
                </h1>

                {loading ? (
                    <div className="text-center py-5">
                        <div className="spinner-border text-danger" role="status">
                            <span className="visually-hidden">Đang tải...</span>
                        </div>
                    </div>
                ) : trainingCourses.length > 0 ? (
                    <div className="row g-4 row-cols-lg-4 row-cols-md-2 row-cols-1 mb-4">
                        {trainingCourses.map((course, idx) => (
                            <div className="col" key={course.id || idx}>
                                <div className="accessory-item h-100 d-flex flex-column">
                                    <Link
                                        to={`/dao-tao/${course.slug || course.id}`}
                                        title={course.title}
                                        className="d-block overflow-hidden"
                                        style={{ height: '250px', borderRadius: '8px 8px 0 0' }}
                                    >
                                        <img
                                            src={normalizeImageUrl(course.thumbnailUrl || '/assets/default-course.jpg')}
                                            alt={course.title}
                                            loading="lazy"
                                            style={{ width: '100%', height: '100%', objectFit: 'cover', transition: '0.5s' }}
                                            className="transition-scale"
                                        />
                                    </Link>
                                    <h3 className="title text-center mb-3 mt-3 px-2 flex-grow-1">
                                        <Link to={`/dao-tao/${course.slug || course.id}`} title={course.title}>
                                            {course.title}
                                        </Link>
                                    </h3>
                                    <div className="text-center mb-3">
                                        <Link to={`/dao-tao/${course.slug || course.id}`} title={course.title} className="btn btn-main">
                                            Chi tiết
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="text-center py-5">
                        <p className="text-muted">Hiện chưa có khóa đào tạo nào được hiển thị.</p>
                    </div>
                )}
            </div>
        </main>
    );
};

export default TrainingPage;




